import axios from "axios";

axios.defaults.withCredentials = true;

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getProducts = (params = {}) =>
  axios.get(`${API}/products`, { params }).then((r) => r.data);

export const getProduct = (slug) =>
  axios.get(`${API}/products/${slug}`).then((r) => r.data);

export const submitQuote = (payload) =>
  axios.post(`${API}/quotes`, payload).then((r) => r.data);

export const submitTrade = (payload) =>
  axios.post(`${API}/trade-applications`, payload).then((r) => r.data);

export const submitContact = (payload) =>
  axios.post(`${API}/contact`, payload).then((r) => r.data);

export const subscribeNewsletter = (email) =>
  axios.post(`${API}/newsletter`, { email }).then((r) => r.data);
